<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2">
            <i class="fa fa-barcode text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Remessa de Boletos</h4>
            <p class="text-muted mb-0 small">Gerenciamento e geração de arquivos de remessa bancária</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <CecInputData ref="dt1Input" v-model="dt1" class="mx-1" style="width: 130px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1 small font-weight-bold">até</span>
                    <CecInputData v-model="dt2" class="mx-1" style="width: 130px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="nova()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Nova Remessa</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">ID Remessa</label>
                      <b-form-input type="text" v-model="idFiltro" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="4">
                      <label class="font-weight-bold text-muted small">Situação</label>
                      <b-form-select v-model="situacao" :options="situacaoOptions" class="custom-input-premium" @change="pesquisar()" @keydown.enter.native="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="6">
                      <label class="font-weight-bold text-muted small">Nome do Arquivo</label>
                      <b-form-input type="text" v-model="arquivoFiltro" placeholder="Parte do nome do arquivo..." class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-3">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              class="modern-premium-table mb-0"
              id="table-remessa"
              ref="tbl"
              show-empty
              empty-text="Informe o filtro para ver os registros"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              :dark="isDark"
              @row-dblclicked="abrirCadastro"
              @row-clicked="clicarLinha"
              :tbody-tr-class="rowClassSelecionado"
            >

              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(DATA_CADASTRO)>
                <SetFilter label="Data Cadastro" v-model="filtros.DATA_CADASTRO" :options="opcoes.DATA_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(CONTA_TRADUZIDO)>
                <SetFilter label="Cedente" v-model="filtros.CONTA_TRADUZIDO" :options="opcoes.CONTA_TRADUZIDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(NOME_ARQUIVO_REMESSA)>
                <SetFilter label="Arquivo" v-model="filtros.NOME_ARQUIVO_REMESSA" :options="opcoes.NOME_ARQUIVO_REMESSA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(STATUS_TRADUZIDO)>
                <SetFilter label="Situação" v-model="filtros.STATUS_TRADUZIDO" :options="opcoes.STATUS_TRADUZIDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(USUARIO_CADASTRO)>
                <SetFilter label="Usuário" v-model="filtros.USUARIO_CADASTRO" :options="opcoes.USUARIO_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(QUANT_BOLETOS)>
                <SetFilter label="Qtd. Boletos" v-model="filtros.QUANT_BOLETOS" :options="opcoes.QUANT_BOLETOS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(VALOR_REMESSA)>
                <SetFilter label="Valor Total" v-model="filtros.VALOR_REMESSA" :options="opcoes.VALOR_REMESSA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(ID)="data">
                <span class="text-muted font-weight-bold">{{ data.value }}</span>
              </template>

              <template #cell(DATA_CADASTRO)="item">
                <span class="text-muted">{{ formatDate(item.item.DATA_CADASTRO) }}</span>
              </template>

              <template #cell(VALOR_REMESSA)="item">
                <span class="font-weight-bold text-primary">{{ formatCurrency(item.item.VALOR_REMESSA) }}</span>
              </template>

              <template #cell(STATUS_TRADUZIDO)="item">
                <b-badge pill :variant="colorirSTATUS(item.item.STATUS)" class="px-3 py-1 shadow-xs">
                  {{item.item.STATUS_TRADUZIDO}}
                </b-badge>
              </template>

              <template #cell(actions)="item">
                <b-button-group size="sm">
                  <b-dropdown
                    right
                    dropup
                    boundary="viewport"
                    :popper-opts="{ positionFixed: true }"
                    no-caret
                    variant="link"
                    toggle-class="p-1 text-muted no-decoration"
                    @shown="clicarLinha(item.item)"
                  >
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() !== '1'"
                      @click.stop="downloadArquivo(item.item)">
                      <i class="fa fa-download text-primary mr-2"></i> Download Arquivo
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() !== '1'"
                      @click.stop="marcarEnviada(item.item)">
                      <i class="fa fa-check-circle text-success mr-2"></i> Marcar como Enviada
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() !== '2'"
                      @click.stop="processarRetorno(item.item)">
                      <i class="fa fa-download text-info mr-2"></i> Processar Arquivo de Retorno
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() === '0'"
                      @click.stop="abrirPastaDestino(item.item)">
                      <i class="fa fa-folder-open text-warning mr-2"></i> Abrir Pasta de Destino
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() === '0'"
                      @click.stop="exportarXmlRemessa(item.item)">
                      <i class="fa fa-file-code-o text-primary mr-2"></i> Exportar XML da Remessa
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() !== '1'"
                      @click.stop="imprimirRemessa(item.item)">
                      <i class="fa fa-print text-secondary mr-2"></i> Imprimir
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item 
                      :disabled="String(item.item.STATUS || '').trim() === '0'"
                      @click.stop="deleteItem(item.item)" 
                      class="text-danger">
                      <i class="fa fa-trash text-danger mr-2"></i> Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </b-button-group>
              </template>

              <template #custom-foot="{ fields, items }">
                <b-tr class="bg-light font-weight-bold">
                  <b-td colspan="6">Total de Registros: {{ itensFiltrados.length }}</b-td>
                  <b-td class="text-right text-primary">{{ totalQuantBoletos }}</b-td>
                  <b-td class="text-right text-primary">{{ formatCurrency(totalValorRemessa) }}</b-td>
                  <b-td></b-td>
                </b-tr>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import moment from 'moment'

export default {
  components: { SetFilter, CecInputData },
  mixins: [createCecTableToolsMixin({ 
    rowsProp: 'lista', 
    tblRef: 'tbl', 
    useExternalPaging: true, 
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DATA_CADASTRO', type: 'date', label: 'Data Cadastro' },
      { key: 'CONTA_TRADUZIDO', type: 'string', label: 'Cedente' },
      { key: 'NOME_ARQUIVO_REMESSA', type: 'string', label: 'Arquivo' },
      { key: 'STATUS_TRADUZIDO', type: 'string', label: 'Situação' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Usuário' },
      { key: 'QUANT_BOLETOS', type: 'number', label: 'Qtd. Boletos' },
      { key: 'VALOR_REMESSA', type: 'number', label: 'Valor Total' }
    ] 
  })],

  data() {
    return {
      isBusy: false,
      lista: [],
      dt1: moment().startOf('month').format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      situacao: null,
      filtroAvancado: false,
      idFiltro: '',
      arquivoFiltro: '',
      situacaoOptions: [
        { value: null, text: 'Todas' },
        { value: '0', text: 'Cancelada' },
        { value: '1', text: 'Cadastrada' },
        { value: '2', text: 'Enviada ao Banco' },
        { value: '3', text: 'Retorno Recebido' }
      ],
      currentPage: 1,
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: '5%' } },
        { key: 'DATA_CADASTRO', label: 'Data Cadastro', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'CONTA_TRADUZIDO', label: 'Cedente', sortable: true, class:'align-middle', thStyle: { width: '20%' } },
        { key: 'NOME_ARQUIVO_REMESSA', label: 'Arquivo', sortable: true, class:'align-middle', thStyle: { width: '13%' } },
        { key: 'STATUS_TRADUZIDO', label: 'Situação', sortable: true, class:'align-middle', thStyle: { width: '12%' } },
        { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'QUANT_BOLETOS', label: 'Qtd. Boletos', sortable: true, class:'align-middle text-right', thStyle: { width: '9%' } },
        { key: 'VALOR_REMESSA', label: 'Valor Total', sortable: true, class:'align-middle text-right', thStyle: { width: '11%' } },
        { key: 'actions', label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: '7%' }, sortable: false }
      ]
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    totalQuantBoletos() {
      return this.itensFiltrados.reduce((sum, item) => sum + (Number(item.QUANT_BOLETOS) || 0), 0)
    },
    
    totalValorRemessa() {
      return this.itensFiltrados.reduce((sum, item) => sum + (Number(item.VALOR_REMESSA) || 0), 0)
    }
  },

  methods: {
    clicarLinha(item) { 
      this.$store.commit('boletoRemessa/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['boletoRemessa/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : '' 
    },
    
    colorirSTATUS(s) {
      if (!s) return 'secondary'
      const status = String(s).trim()
      if (status === '0') return 'danger'    // Cancelada
      if (status === '1') return 'info'      // Cadastrada
      if (status === '2') return 'success'   // Enviada ao Banco
      if (status === '3') return 'primary'   // Retorno Recebido
      return 'secondary'
    },
    
    limparFiltro() { 
      this.dt1 = moment().startOf('month').format('YYYY-MM-DD')
      this.dt2 = moment().format('YYYY-MM-DD')
      this.situacao = null
      this.idFiltro = ''
      this.arquivoFiltro = ''
      this.lista = []
    },
    
    nova() {
      this.$router.push('/faturamento/remessa/cadastro/novo')
    },
    
    abrirCadastro(item) {
      const id = item && item.ID ? item.ID : null
      if (!id) return
      this.$store.commit('boletoRemessa/SET_REGISTRO_SELECIONADO_ID', id)
      this.$router.push(`/faturamento/remessa/cadastro/${id}`)
    },

    async pesquisar() {
      if (!this.dt1 || !this.dt2) {
        this.$bvToast.toast('Informe o período (data inicial e final)', { variant: 'warning', solid: true })
        return
      }

      this.$store.commit('controle/setAguardando', true)
      try {
        const payload = {
          dt1: this.dt1,
          dt2: this.dt2
        }
        
        if (this.situacao !== null && this.situacao !== '') {
          payload.situacao = this.situacao
        }

        if (this.idFiltro) {
          payload.id = this.idFiltro
        }

        if (this.arquivoFiltro) {
          payload.arquivo = this.arquivoFiltro
        }

        const { data } = await this.$http.post('/api/protected/boleto/remessa/pesquisar', payload)
        this.lista = Array.isArray(data) ? data : []
      } catch (err) {
        console.error('Erro ao pesquisar remessas:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao pesquisar remessas'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
        this.lista = []
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async marcarEnviada(item) {
      if (!item || !item.ID) return

      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Confirma marcar a remessa ${item.ID} como enviada?`,
        {
          title: 'Confirmar',
          okVariant: 'success',
          okTitle: 'Sim',
          cancelTitle: 'Não'
        }
      )
      
      if (!confirmado) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/boleto/remessa/marcarEnviada/${item.ID}`)
        this.$bvToast.toast('Remessa marcada como enviada!', { variant: 'success', solid: true })
        await this.pesquisar()
      } catch (err) {
        console.error('Erro ao marcar remessa como enviada:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao marcar remessa'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async processarRetorno(item) {
      this.$bvToast.toast('Processar arquivo de retorno - funcionalidade em desenvolvimento', { variant: 'info', solid: true })
    },

    abrirPastaDestino(item) {
      this.$bvToast.toast('Abrir pasta de destino - funcionalidade em desenvolvimento', { variant: 'info', solid: true })
    },

    async exportarXmlRemessa(item) {
      this.$bvToast.toast('Exportar XML da remessa - funcionalidade em desenvolvimento', { variant: 'info', solid: true })
    },

    async imprimirRemessa(item) {
      if (!item || !item.ID) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        try {
          this.$store.commit('boletoRemessa/SET_REGISTRO_SELECIONADO_ID', item.ID)
          
          const response = await this.$http.get(
            `/api/protected/relatorios/relBoletoRemessa/${item.ID}/${window.localStorage.getItem('login')}`,
            { responseType: 'arraybuffer' }
          )
          
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', `relBoletoRemessa_${item.ID}.pdf`)
          link.download = `relBoletoRemessa_${item.ID}.pdf`
          
          const janela = window.open(link)
          janela.onload = function() {
            setTimeout(() => {
              janela.document.title = `${item.ID} - Relatório de Remessa de Boletos`
            }, 2000)
          }

          this.$bvToast.toast('Relatório gerado com sucesso!', { variant: 'success', solid: true })
        } catch (err) {
          console.error('Erro ao gerar relatório:', err)
          this.$bvToast.toast('Relatório indisponível!', { variant: 'warning', solid: true })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async deleteItem(item) {
      if (!item || !item.ID) return

      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Confirma a exclusão da remessa ${item.ID}?`,
        {
          title: 'Confirmar Exclusão',
          okVariant: 'danger',
          okTitle: 'Sim, Excluir',
          cancelTitle: 'Não'
        }
      )
      
      if (!confirmado) return

      try {
        this.$store.commit('controle/setAguardando', true)
        await this.$http.post(`/api/protected/boleto/remessa/delete/`, { id: item.ID, usuario: window.localStorage.getItem('login') })
        this.$bvToast.toast('Remessa excluída com sucesso!', { variant: 'success', solid: true })
        await this.pesquisar()
      } catch (err) {
        console.error('Erro ao excluir remessa:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao excluir remessa'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async downloadArquivo(item) {
      if (!item || !item.ID) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const { data } = await this.$http.get(`/api/protected/integrador/downloadRemessa/${item.ID}`)
        
        if (data && data.sucesso && data.arquivoRemessaBase64 && data.nomeArquivo) {
          // Converter base64 para blob
          const byteCharacters = atob(data.arquivoRemessaBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'text/plain' })
          
          // Criar link de download e simular clique
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', data.nomeArquivo)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          
          this.$bvToast.toast('Download realizado com sucesso!', { variant: 'success', solid: true })
        } else {
          throw new Error(data?.erro || 'Erro ao fazer download do arquivo')
        }
      } catch (err) {
        console.error('Erro ao fazer download:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao fazer download do arquivo de remessa'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    formatDate(val) { 
      return val ? moment(String(val)).format('DD/MM/YYYY') : '' 
    },
    
    formatCurrency(val) { 
      return val != null ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00' 
    },

    exportarHtml() { 
      printHtmlReport({ 
        rows: this.lista, 
        columns: this.colunas, 
        systemName: 'CECWeb', 
        reportTitle: 'Listagem de Remessas de Boletos', 
        printedBy: window.localStorage.getItem('login') ?? '—', 
        pageSize: 'A4', 
        landscape: true 
      }) 
    },
    
    exportarExcel() { 
      exportExcelXlsx({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'remessa-boletos-lista.xls' 
      }) 
    },
    
    exportarCsv() { 
      exportCsv({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'remessa-boletos-lista.csv' 
      }) 
    }
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.dt1Input) {
        this.$refs.dt1Input.focus()
      }
    })
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('controle/setAguardando', false)
      
      const deveRecarregar = vm.$store.getters['boletoRemessa/DEVE_RECARREGAR_LISTA']
      const vindoDeCadastro = from.path && from.path.includes('/faturamento/remessa/cadastro')
      
      if (deveRecarregar || vindoDeCadastro) {
        vm.$nextTick(() => {
          vm.pesquisar()
          vm.$store.commit('boletoRemessa/SET_DEVE_RECARREGAR_LISTA', false)
        })
      }

      vm.$nextTick(() => {
        if (vm.$refs.dt1Input) {
          vm.$refs.dt1Input.focus()
        }
      })
    })
  }
}
</script>

<style lang="scss">
.list-header-premium {
  background: #fff;
  border-bottom: 1px solid #eef2f7;
  
  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    
    i {
      font-size: 1.4rem;
    }
  }
}

.card-filter-premium {
  background: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px;
}

.custom-input-premium {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  padding: 0.5rem 0.75rem;
  height: 38px;
  transition: all 0.2s;
  
  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
}

.modern-premium-table {
  border-collapse: separate;
  border-spacing: 0;
  
  thead th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
    letter-spacing: 0.025em !important;
    padding: 12px 16px !important;
    border-top: none !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }
  
  tbody td {
    padding: 4px 8px !important;
    vertical-align: middle !important;
    border-bottom: 1px solid #edf2f7 !important;
    font-size: 0.875rem !important;
  }
  
  tbody tr {
    transition: all 0.2s;
    
    &:hover {
      background-color: #f1f5f9 !important;
    }
    
    &.cec-row-selected {
      background-color: #e0f2fe !important;
      td {
        color: #0369a1 !important;
        font-weight: 500;
      }
    }
  }
}

.btn-icon-only {
  width: 28px;
  height: 28px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
</style>



// WEBPACK FOOTER //
// src/views/faturamento/boleto/BoletoRemessaListagem.vue